<template>
  <div class="g-recaptcha" :data-sitekey="siteKey"></div>
</template>

<script>
// This component uses reCAPTCHA v2
// To use reCAPTCHA v3, set "gReCaptcha3" prop as "true" on form-component instance
// And do NOT add this component to the form fields
export default {
  name: 'google-recaptcha-v2',
  props: {
    siteKey: {
      type: String,
      default: '6LenZ4QpAAAAACAaWXfHSL_rzJfva9QrRzbMPcpl'
    }
  },
  beforeMount () {
    const recaptchaScript = document.createElement('script')
    recaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/api.js')
    recaptchaScript.setAttribute('async', '')
    recaptchaScript.setAttribute('defer', '')
    document.getElementsByTagName('head')[0].appendChild(recaptchaScript)
  }
}
</script>

<style scoped>
.g-recaptcha {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 30px 0 10px;
}
</style>